import { useId } from 'react';

import type { ChkIconProps } from './ChkIcon.types';
import { ChkSvgWrapper } from './ChkIcon.utils';

export const ChkIconArrowRight = (iconProps: ChkIconProps) => {
  const clipPathId = useId();

  return (
    <ChkSvgWrapper {...iconProps}>
      <g clipPath={`#url(${clipPathId})`}>
        <path d="M20 12L3 12" stroke="currentColor" strokeWidth="2" />
        <path d="M14 6L20 12L14 18" stroke="currentColor" strokeWidth="2" />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </ChkSvgWrapper>
  );
};
